<template>
  <Dialog :open="isOpenRef" @update:open="onOpenChange">
    <DialogContent class="sm:max-w-2xl max-h-[calc(100vh-4rem)] overflow-y-auto">
      <NewSessionContent v-if="isOpenRef" />
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'

import { Dialog, DialogContent } from '@/components/ui/dialog'
import NewSessionContent from '@/features/sessions/components/new-session-modal/new-session-content/new-session-content.vue'
import { selectGetNewSessionModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { selectGetCurrentRoute } from '@/store/route/route.selector'
import routeStore from '@/store/route/route.store'

const newSessionModalRef = selectGetNewSessionModal(modalsStore)
const isOpenRef = computed(() => !!newSessionModalRef.value?.isOpen)

function onOpenChange(open: boolean) {
  modalsStore.toggleModal('new-session', open)
}

const currentRouteRef = selectGetCurrentRoute(routeStore)
watch(currentRouteRef, () => {
  if (isOpenRef.value) {
    modalsStore.toggleModal('new-session', false)
  }
})
</script>
